import { render, staticRenderFns } from "./ProcessModal.vue?vue&type=template&id=621653c2&scoped=true&"
import script from "./ProcessModal.vue?vue&type=script&lang=js&"
export * from "./ProcessModal.vue?vue&type=script&lang=js&"
import style0 from "./ProcessModal.vue?vue&type=style&index=0&id=621653c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621653c2",
  null
  
)

export default component.exports